import { BaseQueryOptions } from '@apollo/client';

import { MetricCountsQueryVariables, useMetricCountsQuery } from '@occc/graphql';

import { useQuery } from '../utils';

export const useGetMetricCounts = (baseOptions?: BaseQueryOptions<MetricCountsQueryVariables>) =>
  useQuery(useMetricCountsQuery, baseOptions);
